import { useTranslation } from "react-i18next";

import { SNOOZE_DEPARTMENTS } from "models";
import { enumToDropdownOptions } from "utils/common";

export const useDepartmentOptions = () => {
  const { t } = useTranslation();

  return { departmentOptions: enumToDropdownOptions({ enumObj: SNOOZE_DEPARTMENTS, t }) };
};
